import router from '../router'
// import store from './store'
import { Message, MessageBox } from 'element-ui'
import { getQueryString } from "./fun";
import store from "../store"

const whiteList = ['/login', '/register','/resetPassword', '/footer'] // 白名单


router.beforeEach((to, from, next) => {
  // 设置页面标题
  if(getQueryString('access_token')){
    sessionStorage.setItem('accessToken',getQueryString('access_token'))
   }
  const isLogin = sessionStorage.getItem('accessToken')

  if (isLogin) {
    if (!window.sessionStorage.getItem("User")) {
      // 获取用户信息
      console.log("没有用户信息，重新拿取");
      store.dispatch("getUserInfo").then(()=>{
        next();
      });
    }else{
      next();
    }
    // //获取菜单
    // if (store.state.user.routes.length == 0) {
    //   store.dispatch("user/getUserRoles");
    // }
    // if (to.path == '/login') {
    //   Message.error("已有用户登录,请先注销!");
    //   next("/");
    // }
  } else {

    /* 没有token*/
    if (whiteList.indexOf(to.path) !== -1) {

      // 在免费登录白名单中，直接进入
      next()
    } else {
      // 没有访问权限的其他页面将重定向到登录页面。
      next({
        path: '/login',
        query: {
          redirect: to.path,
        }
      })
    }
  }

})
